import { render, staticRenderFns } from "./OperaIntegralShopMoneyWindow.vue?vue&type=template&id=45be05cd&scoped=true&"
import script from "./OperaIntegralShopMoneyWindow.vue?vue&type=script&lang=js&"
export * from "./OperaIntegralShopMoneyWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaIntegralShopMoneyWindow.vue?vue&type=style&index=0&id=45be05cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45be05cd",
  null
  
)

export default component.exports